import { render, staticRenderFns } from "./junkRequirementManageList.vue?vue&type=template&id=04cd65d9&scoped=true"
import script from "./junkRequirementManageList.vue?vue&type=script&lang=js"
export * from "./junkRequirementManageList.vue?vue&type=script&lang=js"
import style0 from "./junkRequirementManageList.vue?vue&type=style&index=0&id=04cd65d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04cd65d9",
  null
  
)

export default component.exports